import { addFilter } from '@situation/setdesign.util';

addFilter('content-slider/owl-settings', (settings) => ({
    ...settings,
    items: 1,
    autoplay: true,
    navText: [
        '<svg class="icon icon-use"><use xlink:href="#icon-arrow"></use></svg>',
        '<svg class="icon icon-use"><use xlink:href="#icon-arrow"></use></svg>',
    ],
    responsive: { 0: { items: 1 } },
}));
